import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import frJson from "./locales/fr.json";
import { LOCALES, resolveLocale } from "@shared/types/locale.ts";

// French must have exactly the English keys: this assignment fails to compile if fr.json drifts.
const fr: typeof en = frJson;

/** The interface language of the browser's locale, until the person's own locale is known. */
function browserLanguage(): "en" | "fr" {
  return LOCALES[resolveLocale(navigator.language)].language;
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    fr: { translation: fr },
  },
  lng: browserLanguage(),
  fallbackLng: "en",
  interpolation: {
    escapeValue: false, // React already escapes output
  },
});

document.documentElement.lang = i18n.language;

export default i18n;

// TypeScript: type the t() function against the English translation keys.
// This gives auto-completion and catches typos at compile time.
declare module "i18next" {
  interface CustomTypeOptions {
    defaultNS: "translation";
    resources: {
      translation: typeof en;
    };
  }
}
